var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 7 12"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#arrow_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.285 12 7 6.012 1.285 0 0 1.092l4.67 4.92L0 10.908z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "arrow_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7 0H0v12h7z"
  })))));
};
export default SvgArrow;